/* eslint-disable no-param-reassign */
import axios from 'axios'

import authOperations from 'redux/auth/authOperations';

import { store } from 'redux/store'

const { getState } = store; // direct access to redux store

const defaults = {
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  // headers: {
  //   Accept: 'application/json',
  //   Authorization: 'Bearer',
  //   'Content-Type': 'application/json',
  // },
}

const $apiPrivate = axios.create(defaults)

$apiPrivate.interceptors.request.use(
  async (config) => {
    const { auth: { accessExpires, accessToken: oldToken } } = getState()

    if (!accessExpires) return

    // Если остаток жизни токена превышает 5 секунд, 
    // записываю его в заголоки для выполнения запроса
    if ((accessExpires - Date.now()) / 1000 > 5) {
      config.headers.Authorization = `Bearer ${oldToken}`

      return config
    }

    // Если остаток жизни токена меньше 5 секунд, обновляю токен
    // и записываю его в заголоки для выполнения запроса
    await authOperations.refreshToken()

    const { auth: { accessToken: newToken } } = getState()

    config.headers.Authorization = `Bearer ${newToken}`

    return config
  },
  error => {
    throw error
  }
)

$apiPrivate.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && error.response?.data?.message !== 'This txid is already in use.') return

    throw error
  }
)

export default $apiPrivate